import { loadStripe } from '@stripe/stripe-js';

// Get Stripe configuration from environment variables
const stripeTestKey = import.meta.env.VITE_STRIPE_TEST_PUBLISHABLE_KEY;
const stripeLiveKey = import.meta.env.VITE_STRIPE_LIVE_PUBLISHABLE_KEY;
const stripeMode = import.meta.env.VITE_STRIPE_MODE || 'test';

// Select the appropriate key based on mode
const stripePublishableKey = stripeMode === 'live' ? stripeLiveKey : stripeTestKey;

// Log the mode for debugging


if (!stripePublishableKey) {
  console.error(`Stripe ${stripeMode} publishable key is missing. Please check your environment variables.`);
  throw new Error(`Missing Stripe ${stripeMode} publishable key`);
}

// Verify that the key format matches the expected mode
const keyPrefix = stripeMode === 'live' ? 'pk_live_' : 'pk_test_';
if (!stripePublishableKey.startsWith(keyPrefix)) {
  console.warn(`Warning: Stripe ${stripeMode} publishable key doesn't match the expected ${keyPrefix} prefix`);
  console.warn(`Key prefix: ${stripePublishableKey.substring(0, 10)}...`);
}

// Initialize Stripe with the selected publishable key
export const stripePromise = loadStripe(stripePublishableKey);

// Export the Stripe mode for use in components
export const isStripeTestMode = stripeMode === 'test';